import React, { FC } from "react";
import { IFormItem } from "../Types";
import { Form, DatePicker } from "antd";

export const __FormDatePicker: FC<IFormItem> = (props) => {
    return (
        <Form.Item
            label={props.fieldLabel}
            name={props.fieldName}
            rules={props.rules}
            hidden={props.hidden}
            labelCol={props.labelCol ?? { span: 24 }}
        >
            <DatePicker
                style={{ width: "100%" }}
                format={props?.format ?? "YYYY-MM-DD"}
                showTime={props.showTime}
                disabledTime={props.disabledDateTime}
                disabled={props.disable}
                allowClear
            />
        </Form.Item>
    )
}